import {
  UserProfileUpdatedEvent,
  userSettingsUpdated,
} from '@webapp/utils/rudderstack/events';

export const updatedUserSideEffect = async ({
  userId,
  full_name,
  country,
  state,
  city,
  zip,
  email_addresses,
  phone_numbers,
  address_line1,
  address_line2,
}: UserProfileUpdatedEvent) => {
  const updateData = {
    userId,
    full_name,
    country,
    state,
    city,
    zip,
    email_addresses,
    phone_numbers,
    address_line1,
    address_line2,
  };

  await userSettingsUpdated(updateData);
};
